window.addEventListener('load', event => {
    document.body.classList.remove('preload');

    // Remove hidden from all hover effects (Without hidden is visible on initial load)
    let navhoverelements = document.querySelectorAll('.nav-hover-effect');

    for (let e of navhoverelements) {
        e.classList.remove('hidden');
    }

    // Remove -rotate-180 from all carets on faq page
    let faqcarets = document.querySelectorAll('.rotate-svg');

    for (let caret of faqcarets) {
        caret.classList.remove('rotate-180');
    }

    document.querySelectorAll('link[data-loadcss]').forEach((link) => {
        link.setAttribute('media','all');
    });
});
